import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatCheckInDate } from '../../../../helpers/formatData';
import JobWorkerTimeline from './JobWorkerTimeline';

export default class JobWorkerHistory extends PureComponent {
  render () {
    const { actual_hours, checkin_at, checkout_at, is_prior_confirmed } = this.props;

    if (actual_hours) {
      return (
        <JobWorkerTimeline {...this.props} />
      );
    }

    if (checkin_at) {
      return (
        <Fragment>
          <div className='text-capitalize'>Checked in: {formatCheckInDate(checkin_at)}</div>
          {checkout_at && (
            <div className='text-capitalize'>Checked out: {formatCheckInDate(checkout_at)}</div>
          )}
        </Fragment>
      );
    }

    if (is_prior_confirmed) {
      return (
        <div className='text-capitalize'>Confirmed to work</div>
      );
    }

    return null;
  }
}

JobWorkerHistory.propTypes = {
  actual_hours: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object
  ]),
  checkin_at: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  checkout_at: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  is_prior_confirmed: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobInfoWorker/JobWorkerHistory.js